export default __webpack_public_path__ + "static/ecssd-view-log-7a8916021a1c5b95fa0a322964556968.png";